import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export function trackHeaderButtonMarkAsStarredClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'mark_message_as_starred',
    category: 'Chat',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackHeaderButtonUnmarkAsStarredClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'mark_message_as_starred_cancel',
    category: 'Chat',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
